namespace $.$$ {
	export class $shm_hitalama_components_drafts_editor extends $.$shm_hitalama_components_drafts_editor {
		name( next?: string ) { return this.model().title( this.selected(), next ) }
		image_owner() {
			if( !this.model().can_change() ) throw new Error( 'Нет прав на изменение черновика.' )
			return this.model().entry( this.selected() )!
		}
		@ $mol_mem
		focus_auto() {
			const id = this.selected()
			return new this.$.$mol_after_frame( ()=> {
				if( this.selected() === id && this.dom_node().isConnected ) $mol_wire_async( this ).focus_end( id )
			} )
		}
		@ $mol_action
		focus_end( id: string ) {
			if( this.selected() !== id || !this.dom_node().isConnected ) return null
			const input = this.Text()
			const end = input.value().length
			input.Edit().focused( true )
			input.selection([ end, end ])
			return null
		}
		text( next?: string ) { return this.model().text( this.selected(), next ) }
		@ $mol_action
		close( event?: Event | null ) { if( event ) this.editing( false ); return null }
		@ $mol_action
		remove( event?: Event | null ) {
			if( event ) { this.model().remove( this.selected() ); this.removed( event ) }
			return null
		}
	}
}
